import React, { useEffect, useRef } from "react";
import "./AnimatedLogo.css";

/**
 * AnimatedLogo — affiche le LOGO OFFICIEL Gively (/logo-gively.svg, source unique)
 * avec une apparition douce (fondu + léger zoom).
 *
 * Décision Lucas (juin 2026) : on SUPPRIME l'ancien rendu "camembert" reconstruit
 * (conic-gradient + G vectoriel + halo violet) qui flashait au chargement un logo
 * DIVERGENT de l'icône officielle (trop de violet, G plus petit, anneau de
 * révélation). Le logo de chargement est désormais PIXEL-IDENTIQUE à l'icône
 * officielle, partout (splash, onboarding).
 *
 * API conservée : size, duration, play, replayKey, onComplete, className, title.
 */
export default function AnimatedLogo({
  size = 96,
  duration = 1.4,
  play = true,
  replayKey = 0,
  onComplete,
  className = "",
  title = "Gively",
}) {
  const doneRef = useRef(false);

  useEffect(() => {
    if (!play || !onComplete) return;
    doneRef.current = false;
    const ms = duration * 1000 + 250;
    const t = setTimeout(() => {
      if (!doneRef.current) {
        doneRef.current = true;
        onComplete();
      }
    }, ms);
    return () => clearTimeout(t);
  }, [play, replayKey, duration, onComplete]);

  return (
    <span
      className={`gv-logo ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={title}
    >
      <img
        src="/logo-gively.svg"
        alt={title}
        width={size}
        height={size}
        className={play ? "gv-logo__img gv-logo__img--in" : "gv-logo__img"}
        style={{ width: size, height: size }}
      />
    </span>
  );
}
